import { Loader } from '../loader';
import { MessageContainer } from './message';

export const Typing = () => (
  <MessageContainer role="assistant">
    <Loader />
  </MessageContainer>
);
